// extracted by mini-css-extract-plugin
module.exports = {"saturday":"saturday__T2LYj","sunday":"sunday__22OJs"};